var module = angular.module('octopusApp.environments');

module.directive('machinePolicySummary', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
        machinePolicy: '=',
        hideDescription: '='
    },
    templateUrl: 'areas/environments/machines/machine_policy_summary.html',
    link: function(scope, element) {
        function parseTimeSpan(timeSpan)
        {
            var timeSpanParts = timeSpan.split(":");
            
            var days = 0;
            var hours = 0;
            var mins = 0;
            var tsPart1 = timeSpanParts[0];
            if (tsPart1.indexOf(".") !== -1) {
                // days included
                var daysAndHours = tsPart1.split(".");
                days = parseInt(daysAndHours[0]);
                hours = parseInt(daysAndHours[1]);
                mins = parseInt(timeSpanParts[1]);
            } else {
                // no days
                hours = parseInt(timeSpanParts[0]);
                mins = parseInt(timeSpanParts[1]);
            }
            return {
                Days: days,
                Hours: hours,
                Minutes: mins
            };
        }

        var reload = function() {
            if (scope.machinePolicy == null) {
                return;
            }
            var policy = scope.machinePolicy;

            var healthCheckInterval = parseTimeSpan(policy.MachineHealthCheckPolicy.HealthCheckInterval);
            var healthCheckIntervalHtml = 'Performs health checks every';
            if (healthCheckInterval.Days > 0) {
                healthCheckIntervalHtml += ' ' + healthCheckInterval.Days + ' day' + (healthCheckInterval.Days === 1 ? '' : 's');
            }
            if (healthCheckInterval.Hours > 0) {
                healthCheckIntervalHtml += ' ' + healthCheckInterval.Hours + ' hour' + (healthCheckInterval.Hours === 1 ? '' : 's');
            }
            if (healthCheckInterval.Minutes > 0 || healthCheckInterval.Hours === 0) {
                healthCheckIntervalHtml += ' ' + healthCheckInterval.Minutes + ' minute' + (healthCheckInterval.Minutes === 1 ? '' : 's');
            }
            scope.healthCheckIntervalHtml = healthCheckIntervalHtml;

            var tentacleEndpointHealthCheckHtml = '';
            if (policy.MachineHealthCheckPolicy.TentacleEndpointHealthCheckPolicy.RunType === 'InheritFromDefault') {
                tentacleEndpointHealthCheckHtml = 'Inherits from the default machine policy';
            } else if (policy.MachineHealthCheckPolicy.TentacleEndpointHealthCheckPolicy.RunType === 'Inline') {
                tentacleEndpointHealthCheckHtml = 'Uses custom script';
            }
            scope.tentacleEndpointHealthCheckHtml = tentacleEndpointHealthCheckHtml;

            var sshEndpointHealthCheckHtml = '';
            if (policy.MachineHealthCheckPolicy.SshEndpointHealthCheckPolicy.RunType === 'InheritFromDefault') {
                sshEndpointHealthCheckHtml = 'Inherits from the default machine policy';
            } else if (policy.MachineHealthCheckPolicy.SshEndpointHealthCheckPolicy.RunType === 'Inline') {
                sshEndpointHealthCheckHtml = 'Uses custom script';
            } else if (policy.MachineHealthCheckPolicy.SshEndpointHealthCheckPolicy.RunType === 'OnlyConnectivity') {
                sshEndpointHealthCheckHtml = 'Only performs connection test';
            }
            scope.sshEndpointHealthCheckHtml = sshEndpointHealthCheckHtml;

            var machineConnectivityHtml = '';
            if (policy.MachineConnectivityPolicy.MachineConnectivityBehavior === 'ExpectedToBeOnline') {
                machineConnectivityHtml = 'Fails when a machine is unavailable';
            } else if (policy.MachineConnectivityPolicy.MachineConnectivityBehavior === 'MayBeOfflineAndCanBeSkipped') {
                machineConnectivityHtml = 'Ignore unavailable machines';
            }
            scope.machineConnectivityHtml = machineConnectivityHtml;

            var machineCalamariUpdatesHtml = '';
            if (policy.MachineUpdatePolicy.CalamariUpdateBehavior === 'UpdateOnDeployment') {
                machineCalamariUpdatesHtml = 'Automatically update when a machine is involved in a deployment';
            } else if (policy.MachineUpdatePolicy.CalamariUpdateBehavior === 'UpdateOnNewMachine') {
                machineCalamariUpdatesHtml = 'Automatically update the first time a machine comes online and then when it is involved in a deployment';
            } else if (policy.MachineUpdatePolicy.CalamariUpdateBehavior === 'UpdateAlways') {
                machineCalamariUpdatesHtml = 'Always keep up to date';
            }
            scope.machineCalamariUpdatesHtml = machineCalamariUpdatesHtml;

            var machineTentacleUpdatesHtml = '';
            if (policy.MachineUpdatePolicy.TentacleUpdateBehavior === 'NeverUpdate') {
                machineTentacleUpdatesHtml = 'Do not update';
            } else if (policy.MachineUpdatePolicy.TentacleUpdateBehavior === 'Update') {
                machineTentacleUpdatesHtml = 'Automatically update';
            }
            scope.machineTentacleUpdatesHtml = machineTentacleUpdatesHtml;

            var cleaningUpOfflineHtml = '';
            if (policy.MachineCleanupPolicy.DeleteMachinesBehavior === 'DoNotDelete') {
                cleaningUpOfflineHtml = 'Does not delete machines automatically';
            } else if (policy.MachineCleanupPolicy.DeleteMachinesBehavior === 'DeleteUnavailableMachines') {
                
                var deleteMachinesElapsedTimeSpan = parseTimeSpan(policy.MachineCleanupPolicy.DeleteMachinesElapsedTimeSpan);
                var deleteMachinesElapsedTimeSpanHtml = 'Automatically delete unavailable machines after';
                if (deleteMachinesElapsedTimeSpan.Days > 0) {
                    deleteMachinesElapsedTimeSpanHtml += ' ' + deleteMachinesElapsedTimeSpan.Days + ' day' + (deleteMachinesElapsedTimeSpan.Days === 1 ? '' : 's');
                }
                if (deleteMachinesElapsedTimeSpan.Hours > 0) {
                    deleteMachinesElapsedTimeSpanHtml += ' ' + deleteMachinesElapsedTimeSpan.Hours + ' hour' + (deleteMachinesElapsedTimeSpan.Hours === 1 ? '' : 's');
                }
                if (deleteMachinesElapsedTimeSpan.Minutes > 0 || deleteMachinesElapsedTimeSpan.Hours === 0) {
                    deleteMachinesElapsedTimeSpanHtml += ' ' + deleteMachinesElapsedTimeSpan.Minutes + ' minute' + (deleteMachinesElapsedTimeSpan.Minutes === 1 ? '' : 's');
                }
                cleaningUpOfflineHtml = deleteMachinesElapsedTimeSpanHtml;
            }
            scope.cleaningUpOfflineHtml = cleaningUpOfflineHtml;

        };

        scope.$watch("machinePolicy", function() {
            reload();
        });
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/directives/machine_policy_summary.js
// module id = 4231335476383847
// module chunks = 1